export type UpdateAlertsSymbolAction = { type: 'updateAlertsSymbol'; tabId: string; symbol: string };
export const updateAlertsSymbol = (tabId: string, symbol: string): UpdateAlertsSymbolAction => ({
    tabId,
    symbol,
    type: 'updateAlertsSymbol',
});

export type UpdateActiveAlertsTabAction = {
    type: 'updateActiveAlertsTab';
    tabId: string;
    activeAlertsTab: 'symbols' | 'ideas';
};
export const updateActiveAlertsTab = (
    tabId: string,
    activeAlertsTab: 'symbols' | 'ideas',
): UpdateActiveAlertsTabAction => ({
    tabId,
    activeAlertsTab,
    type: 'updateActiveAlertsTab',
});

export type AlertsWidgetActions = UpdateAlertsSymbolAction | UpdateActiveAlertsTabAction;
